import { RouteObject } from 'react-router';
import { TowerRoutes } from '../../../RouteConstants';
import { RouteErrorPage } from '@components/ErrorBoundary';
import LoadingIndicator from '@components/LoadingIndicatorMaterial/LoadingIndicator';

export const TowerChildRoutes: RouteObject[] = [
  {
    path: `${TowerRoutes.dashboard.base}/*`,
    hydrateFallbackElement: <LoadingIndicator isLoading={true} />,
    async lazy() {
      const Tower360 = (await import('../../../../Apps/Tower360/Tower360')).default;

      return {
        element: <Tower360 />,
        errorElement: <RouteErrorPage />,
      };
    },
    children: [
      {
        path: `${TowerRoutes.dashboard.decisionBoards.base}`,
        hydrateFallbackElement: <LoadingIndicator isLoading={true} />,
        async lazy() {
          const DecisionBoards = (
            await import('../../../../Apps/Tower360/DecisionBoard/DecisionBoard')
          ).default;

          return {
            element: <DecisionBoards />,
            errorElement: <RouteErrorPage />,
          };
        },
      },
    ],
  },
];
